export enum MyChartMedicalDataTypes {
  SICK_NOTES = 'AM',
  PRESCRIPTIONS = 'RM',
  ALL = 'ALL',
}